import React from "react";
import { useState } from "react";
import { Col, Row } from "reactstrap";
import {
  getDateFromISO,
  getTimeFromISO,
  mergeDateandTime,
} from "../../util/view";
import SeshMetadata from "./SeshMetadata";
import SeshSwellTide from "./SeshSwellTide";
import SeshSummary from "./SeshSummary";

const formatSeshData = (sesh) => {
  const { date, tidesAttributes, ...rest } = sesh;
  const { startTime, endTime } = rest;
  console.log(sesh);
  const startDate = mergeDateandTime(date, startTime);
  const endDate = mergeDateandTime(date, endTime);
  tidesAttributes.forEach((t, ndx) => {
    if (ndx % 2) {
      t.time = endDate;
    } else {
      t.time = startDate;
    }
  });

  return {
    ...rest,
    startTime: startDate,
    endTime: endDate,
    tidesAttributes,
  };
};

const steps = ["Sesh Details", "Tides and Swells", "Summary"];
const defaultValues = {
  createdAt: "",
  description: "",
  endTime: "",
  id: "",
  rating: 0,
  startTime: "",
  swellsAttributes: [],
  tidesAttributes: [],
  updatedAt: "",
  spotId: -1,
  spot: {},
  user: {},
};

const formatSeshToEdit = (seshToEdit) => {
  return {
    ...seshToEdit,
    date: getDateFromISO(seshToEdit.startTime),
    startTime: getTimeFromISO(seshToEdit.startTime),
    endTime: getTimeFromISO(seshToEdit.endTime),
  };
};

const NewSeshForm = ({
  handleSubmit,
  handleCancel,
  handleDelete,
  seshToEdit,
  editMode,
}) => {
  const startValues = editMode ? formatSeshToEdit(seshToEdit) : defaultValues;
  const [formData, setFormData] = useState(startValues);
  const [step, setStep] = useState(0);

  const updateFormData = (values) => {
    setFormData((prev) => ({ ...prev, ...values }));
  };
  const submitClick = (values) => {
    const formatted = formatSeshData(values);
    console.log("formatted: ", formatted);
    handleSubmit(formatted);
  };
  const handleNextStep = (values) => {
    if (step === steps.length - 1) {
      submitClick(values);
    } else {
      updateFormData(values);
      setStep((prev) => prev + 1);
    }
  };
  const handlePrevStep = (values) => {
    if (step <= 0) {
      handleCancel();
    } else {
      setStep((prev) => prev - 1);
    }
  };

  const renderStep = (step, formData, updateFormData) => {
    switch (step) {
      case 0:
        return (
          <SeshMetadata
            formData={formData}
            next={handleNextStep}
            prev={handlePrevStep}
          />
        );
      case 1:
        return (
          <SeshSwellTide
            formData={formData}
            next={handleNextStep}
            prev={handlePrevStep}
          />
        );
      case 2:
        return (
          <SeshSummary
            formData={formData}
            next={handleNextStep}
            prev={handlePrevStep}
          />
        );
      default:
        return <SeshSummary next={handleNextStep} prev={handlePrevStep} />;
    }
  };
  return (
    <>
      <Row>
        <Col>{renderStep(step, formData, updateFormData)}</Col>
      </Row>
    </>
  );
};

export default NewSeshForm;
